import { __rest } from "tslib";
import React from 'react';
import { default as getVariationsFromProps } from "@pb/utils/common/getVariationsFromProps";
import cn from 'classnames';
import styles from './FormLabel.module.scss';
const FormLabel = (_a) => {
    var { Tag = 'label', className, children } = _a, props = __rest(_a, ["Tag", "className", "children"]);
    const [variationsClassNames, passableProps] = getVariationsFromProps(props, styles);
    return (React.createElement(Tag, Object.assign({ className: cn(styles.label, className, variationsClassNames) }, passableProps), children));
};
export default FormLabel;
//# sourceMappingURL=FormLabel.js.map